export default __webpack_public_path__ + "static/media/AHUSVGFLAT.c58bce30.svg";